/**
 * 设置查询日期
 * @author ammo 2018-06-08
 * @param  {[type]} startDate [description]
 * @param  {[type]} endDate   [description]
 * @return {[type]}           [description]
 */
export function updateQueryDate(startDate, endDate){
	this.setState({
		query: {
			startDate: startDate || this.state.query.startDate,
			endDate: endDate || this.state.query.endDate
		}
	})
}